import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

//style rules
import { Colors } from "../../../styles";

const CardTags = ({communities}) => {
	if (!communities.length > 0)	return null;

	const tags = communities.map( community => {
		const frTags = {
			"2slgbtqia-fr": "2slgbtqia",
			"autochtone": "indigenous",
			"femmes": "women",
			"noir-e": "black",
			"nouveaux-arrivants": "newcommers",
		}
		
		if (frTags[community.slug]) return {title: community.title, slug: frTags[community.slug]};

		if (community.slug === "newcomers") return {title: community.title, slug: "newcommers"};

		return community;
	});

	return (
		<CardTagsContainer>
			{tags.map( tag => {
				return <CardTag key={tag.slug}><TagIcon alt={tag.title} src={`${mainScript.assetPath}images/svg/icons/${tag.slug}.svg`} /></CardTag>
			})}		
		</CardTagsContainer>
	);
}

CardTags.propTypes = {
	communities: PropTypes.array,
};

export default CardTags;

const CardTag = styled.li`
	width: fit-content;
	margin-bottom: unset;
`;

const TagIcon = styled.img`
	max-height: 2.6rem;
	height: 100%;
	width: auto;
`;

const CardTagsContainer = styled.ul`
	list-style-type: none;
	display: flex;
	padding: 0.5rem 1rem;
	border-radius: 1rem 1rem 0 0;
	background-color: ${Colors.fp.pineGreen20};
	column-gap: 0.7rem;
	margin: unset;
	position: absolute;
	right: 1.2rem;
	top: -2.5rem;
`;
